import React from "react"
import "./src/assets/styles.css"
import "./src/assets/resources.css"
import "react-toastify/dist/ReactToastify.css"

// import "skillstrainer-resource-library/css/styles.css
import { wrapPageElement as ssrWrapPageElement } from "./gatsby-ssr"

export const wrapPageElement = ssrWrapPageElement
